"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const boolToValue_1 = __importDefault(require("./boolToValue"));
const valueToBool_1 = __importDefault(require("./valueToBool"));
function _logicCalc(operand1, operator, operand2) {
    switch (operator) {
        case '==': return operand1 == operand2;
        case '!=': return operand1 != operand2;
        case '===': return parseFloat(operand1) == parseFloat(operand2);
        case '!==': return parseFloat(operand1) != parseFloat(operand2);
        case '>': return parseFloat(operand1) > parseFloat(operand2);
        case '<': return parseFloat(operand1) < parseFloat(operand2);
        case '>=': return parseFloat(operand1) >= parseFloat(operand2);
        case '<=': return parseFloat(operand1) <= parseFloat(operand2);
        case '||': return valueToBool_1.default(operand1) || valueToBool_1.default(operand2);
        case '&&': return valueToBool_1.default(operand1) && valueToBool_1.default(operand2);
        case '!': return !valueToBool_1.default(operand1);
        default: throw new SyntaxError('Invalid operator.');
    }
}
function logicCalc(operand1, operator, operand2) {
    return boolToValue_1.default(_logicCalc(operand1, operator, operand2));
}
exports.default = logicCalc;
